import { InputSwitch, InputText } from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';

import { useGlobalization } from '@Translations/useGlobalization';

import React from 'react';
import { VaparSettingsFormValues } from 'features/IntegrationsTab/types/integration.types';

export default function VaparSettingsValues() {
	const { t } = useGlobalization();
	const { errors } = useFormikContext<VaparSettingsFormValues>();
	return (
		<div>
			<InputText
				fieldAttrs={{ name: 'name' }}
				textField={{
					label: t('Name Integration'),
					error: !!errors.name,
					helperText: errors.name,
					disabled: false,
				}}
				dataCy="arcgis-name-input"
			/>
			<InputSwitch
				fieldAttrs={{ name: 'enabledAiDefault' }}
				switchProps={{}}
				label={'Enable AI processing for new inspections by default'}
			/>
		</div>
	);
}
